import { Trans } from 'react-i18next';
import Modal, { ModalProps } from '../Modal';
import { useGenericMutation } from '@/legacy/hooks/useGenericMutation';
import { RequestMethod } from '@/legacy/types';

export type ConfirmModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onExitComplete?: () => void;
	title: string;
	description: string;
	endpoint?: string;
	method?: RequestMethod;
	payload?: any;
	successMessage?: string;
	errorMessage?: string;
	invalidateDataKeys?: string[];
	onSuccess?: (data: any) => void;
	onConfirm?: () => void;
	children?: React.ReactNode;
	actionId?: string;
} & Partial<ModalProps>;

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	isOpen,
	onClose,
	onExitComplete,
	title,
	description,
	endpoint,
	method,
	payload,
	successMessage = '',
	errorMessage = '',
	invalidateDataKeys,
	onSuccess = () => {},
	onConfirm,
	children,
	actionId,
	confirmText,
	onCancel,
}) => {
	const { mutate, isPending } = useGenericMutation({
		onSuccess: onSuccess,
		onError: () => {
			onClose();
		},
		successMessage: successMessage,
		errorMessage: errorMessage,
		invalidateKeys: invalidateDataKeys,
	});

	const handleConfirm = () => {
		if (onConfirm) {
			onConfirm();
		} else {
			mutate({
				endpoint: endpoint,
				method: method,
				payload: payload,
				actionId,
			});
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			onExitComplete={onExitComplete}
			title={title}
			onCancel={onCancel}
			onConfirm={handleConfirm}
			isLoading={isPending}
			confirmText={confirmText}
		>
			<p>
				<Trans
					i18nKey={description}
					components={{ b: <strong /> }}
				/>
			</p>
			{children}
		</Modal>
	);
};

export default ConfirmModal;
